import { SystemType } from '@bpos';

import { SystemKey } from '../models';

export function convertSystem(systemType: string): SystemType {
    switch (systemType) {
        case SystemKey.Yankee:
            return SystemType.SystemYankee;
        case SystemKey.Heinz:
            return SystemType.SystemHeinz;
        case SystemKey.Patent:
            return SystemType.SystemPatent;
        case SystemKey.Canadian:
            return SystemType.SystemCanadian;
        case SystemKey.Goliath:
            return SystemType.SystemGoliath;
        case SystemKey.Lucky15:
            return SystemType.SystemLucky15;
        case SystemKey.Lucky31:
            return SystemType.SystemLucky31;
        case SystemKey.Lucky63:
            return SystemType.SystemLucky63;
        case SystemKey.SuperHeinz:
            return SystemType.SystemSuperHeinz;
        case SystemKey.Trixie:
            return SystemType.SystemTrixie;
        case SystemKey.MOfN:
            return SystemType.SystemMOfN;
        case SystemKey.BankerSingles:
            return SystemType.SystemBankerSingles;
        default:
            return systemType as SystemType;
    }
}

export function reconvertSystem(systemType: string): string {
    switch (systemType) {
        case SystemType.SystemYankee:
            return SystemKey.Yankee;
        case SystemType.SystemHeinz:
            return SystemKey.Heinz;
        case SystemType.SystemPatent:
            return SystemKey.Patent;
        case SystemType.SystemCanadian:
            return SystemKey.Canadian;
        case SystemType.SystemGoliath:
            return SystemKey.Goliath;
        case SystemType.SystemLucky15:
            return SystemKey.Lucky15;
        case SystemType.SystemLucky31:
            return SystemKey.Lucky31;
        case SystemType.SystemLucky63:
            return SystemKey.Lucky63;
        case SystemType.SystemSuperHeinz:
            return SystemKey.SuperHeinz;
        case SystemType.SystemTrixie:
            return SystemKey.Trixie;
        case SystemType.SystemMOfN:
            return SystemKey.MOfN;
        case SystemType.SystemBankerSingles:
            return SystemKey.BankerSingles;
        default:
            return systemType;
    }
}
